import axios from "axios";
import { toast } from "react-toastify";
import Web3 from "web3";

export const toFixed = (x) => {
  if (Math.abs(x) < 1.0) {
    var e1 = parseInt(x.toString().split("e-")[1]);
    if (e1) {
      x *= Math.pow(10, e1 - 1);
      x = "0." + new Array(e1).join("0") + x.toString().substring(2);
    }
  } else {
    var e = parseInt(x.toString().split("+")[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += new Array(e + 1).join("0");
    }
  }
  return x;
};

//format transaction hash
export const formathash = (hash) => {
  if (hash) {
    let firsthalf = hash.slice(0, 4);
    let secondhalf = hash.slice(-3);
    let formattedhash = firsthalf + "..." + secondhalf;
    return formattedhash;
  }
};

export const formatAddress = (address) => {
  if (!address) return "";
  const start = address.slice(0, 6);
  const end = address.slice(-4);
  return `${start}...${end}`;
};

const fetchTokenBalancesFromCovalent = async (walletAddress, chainId) => {
  const apiKey = "cqt_rQ4RWCMpYwmCgwXpTCG9gdQjyrwX"; // Replace with your Covalent API key
  const url = `https://api.covalenthq.com/v1/${chainId}/address/${walletAddress}/balances_v2/?key=${apiKey}`;

  try {
    const response = await axios.get(url);
    const data = response.data;
    if (data.error === false) {
      console.log(data.data);
      return data.data.items.map((token) => {
        console.log();
        if (!token.native_token) {
          return {
            tokenAddress: token.contract_address,
            symbol: token.contract_ticker_symbol,
            decimal: token.contract_decimals,
            balance: (
              token.balance / Math.pow(10, token.contract_decimals)
            ).toFixed(4),
          };
        }
      });
    } else {
      throw new Error(data.error_message);
    }
  } catch (error) {
    console.error("Error fetching token balances:", error);
    return null;
  }
};

// Alternative API implementations for better token fetching
export const fetchTokensFromMoralis = async (walletAddress, chainId) => {
  try {
    // Check if API key is configured
    const apiKey = process.env.REACT_APP_MORALIS_API_KEY ||"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjMzYjJiM2E5LWZkYTctNGU3OC1iMmQ1LTkwNGFkZGQ0MmU4MSIsIm9yZ0lkIjoiNDcxMzc2IiwidXNlcklkIjoiNDg0OTEzIiwidHlwZUlkIjoiYzZjOWVmNTktYzBjYi00Zjc2LWJjYjktM2ZlYWQ4ZTBiMTU2IiwidHlwZSI6IlBST0pFQ1QiLCJpYXQiOjE3NTgxOTQ5MDgsImV4cCI6NDkxMzk1NDkwOH0.14f7e1aQKmlj5hbLeNH_D9L0yRIc3eigtYhRB2c8KNc";
    if (!apiKey || apiKey === "YOUR_MORALIS_API_KEY" || apiKey === "your_moralis_api_key_here") {
      console.log("⚠️ Moralis API key not configured, skipping...");
      return null;
    }
    
    const chainMapping = {
      1: "eth",           // Ethereum
      56: "bsc",          // Binance Smart Chain
      137: "polygon",     // Polygon
      42161: "arbitrum",  // Arbitrum One
      10: "optimism",     // Optimism
      43114: "avalanche", // Avalanche
      250: "fantom",      // Fantom
      8453: "base"        // Base
    };
    
    const chain = chainMapping[chainId];
    if (!chain) {
      console.log(`⚠️ Unsupported chain ID for Moralis: ${chainId}, skipping...`);
      return null;
    }
    
    console.log(`🚀 Querying Moralis API for wallet ${walletAddress} on ${chain} (chainId: ${chainId})`);
    console.log(`🔗 API URL: https://deep-index.moralis.io/api/v2.2/${walletAddress}/erc20?chain=${chain}`);
    
    const response = await axios.get(
      `https://deep-index.moralis.io/api/v2.2/${walletAddress}/erc20`,
      {
        params: { 
          chain,
          limit: 100 // Get up to 100 tokens
        },
        headers: { "X-API-Key": apiKey }
      }
    );
    
    const tokens = response.data
      .filter(token => parseFloat(token.balance) > 0)
      .map(token => ({
        tokenAddress: token.token_address,
        symbol: token.symbol,
        decimal: token.decimals,
        balance: (parseFloat(token.balance) / Math.pow(10, token.decimals)).toFixed(4),
        requestedChain: chain,
        requestedChainId: chainId
      }));
    
    console.log(`📊 Moralis returned ${tokens.length} tokens for ${chain} (${chainId}):`, 
      tokens.map(t => `${t.symbol} (${t.tokenAddress.substring(0, 8)}...)`));
    
    return tokens;
  } catch (error) {
    console.error("Error fetching tokens from Moralis:", error);
    return null;
  }
};

export const fetchTokensFromAlchemy = async (walletAddress, chainId) => {
  try {
    // Check if API key is configured
    const apiKey = process.env.REACT_APP_ALCHEMY_API_KEY;
    if (!apiKey || apiKey === "YOUR_ALCHEMY_API_KEY") {
      console.log("⚠️ Alchemy API key not configured, skipping...");
      return null;
    }
    
    const networkMapping = {
      1: "eth-mainnet",
      137: "polygon-mainnet",
      10: "opt-mainnet",
      42161: "arb-mainnet"
    };
    
    const network = networkMapping[chainId];
    if (!network) {
      console.log(`⚠️ Unsupported chain ID for Alchemy: ${chainId}, skipping...`);
      return null;
    }
    
    const response = await axios.post(
      `https://${network}.g.alchemy.com/v2/${apiKey}`,
      {
        jsonrpc: "2.0",
        method: "alchemy_getTokenBalances",
        params: [walletAddress],
        id: 42
      }
    );
    
    if (response.data.error) {
      throw new Error(response.data.error.message);
    }
    
    return response.data.result.tokenBalances
      .filter(token => token.tokenBalance !== "0x0")
      .map(token => ({
        tokenAddress: token.contractAddress,
        symbol: "Unknown", // Alchemy requires separate call for metadata
        decimal: 18, // Default, would need additional call for exact decimals
        balance: (parseInt(token.tokenBalance, 16) / Math.pow(10, 18)).toFixed(4)
      }));
  } catch (error) {
    console.error("Error fetching tokens from Alchemy:", error);
    return null;
  }
};

export const fetchTokensFromEtherscan = async (walletAddress, chainId) => {
  try {
    // Only works for Ethereum mainnet
    if (chainId !== 1) {
      console.log(`⚠️ Etherscan only supports Ethereum mainnet (chainId: 1), got ${chainId}, skipping...`);
      return null;
    }
    
    // Check if API key is configured (optional for Etherscan)
    const apiKey = process.env.REACT_APP_ETHERSCAN_API_KEY || "YourApiKeyToken";
    
    // Get ERC-20 token transfers to find tokens the wallet has interacted with
    const response = await axios.get(
      `https://api.etherscan.io/api`,
      {
        params: {
          module: "account",
          action: "tokentx",
          address: walletAddress,
          startblock: 0,
          endblock: 99999999,
          sort: "desc",
          apikey: apiKey
        }
      }
    );
    
    if (response.data.status !== "1") {
      throw new Error(response.data.message || "Etherscan API error");
    }
    
    // Get unique token contracts from transactions
    const uniqueTokens = new Map();
    response.data.result.forEach(tx => {
      if (!uniqueTokens.has(tx.contractAddress)) {
        uniqueTokens.set(tx.contractAddress, {
          contractAddress: tx.contractAddress,
          tokenName: tx.tokenName,
          tokenSymbol: tx.tokenSymbol,
          tokenDecimal: parseInt(tx.tokenDecimal)
        });
      }
    });
    
    // Get current balance for each token
    const tokenBalances = [];
    const tokenArray = Array.from(uniqueTokens.values()).slice(0, 20); // Limit to 20 tokens to avoid rate limits
    
    for (const token of tokenArray) {
      try {
        const balanceResponse = await axios.get(
          `https://api.etherscan.io/api`,
          {
            params: {
              module: "account",
              action: "tokenbalance",
              contractaddress: token.contractAddress,
              address: walletAddress,
              tag: "latest",
              apikey: apiKey
            }
          }
        );
        
        if (balanceResponse.data.status === "1" && balanceResponse.data.result !== "0") {
          const balance = parseFloat(balanceResponse.data.result) / Math.pow(10, token.tokenDecimal);
          if (balance > 0) {
            tokenBalances.push({
              tokenAddress: token.contractAddress,
              symbol: token.tokenSymbol,
              decimal: token.tokenDecimal,
              balance: balance.toFixed(4)
            });
          }
        }
        
        // Rate limiting - wait 200ms between calls (5 calls/second)
        await new Promise(resolve => setTimeout(resolve, 200));
      } catch (error) {
        console.warn(`Failed to get balance for token ${token.tokenSymbol}:`, error.message);
      }
    }
    
    return tokenBalances;
  } catch (error) {
    console.error("Error fetching tokens from Etherscan:", error);
    return null;
  }
};

// Simple token fetching without external APIs (manual entry only)
export const getManualTokenEntry = () => {
  return {
    message: "No API keys configured. You can still use the app by manually entering token addresses.",
    instructions: [
      "1. Get your token contract address from a blockchain explorer",
      "2. Paste it in the 'Token Address' field above", 
      "3. The app will automatically fetch token details",
      "4. Or toggle 'Use Native Token' to send native tokens"
    ]
  };
};

// Network-specific token validation
// Known token addresses per network to catch API errors
const KNOWN_TOKEN_ADDRESSES = {
  // BSC (Chain ID: 56)
  56: {
    'USDT': '0x55d398326f99059ff775485246999027b3197955',
    'USDC': '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    'BUSD': '0xe9e7cea3dedca5984780bafc599bd69add087d56'
  },
  // Ethereum (Chain ID: 1)
  1: {
    'USDT': '0xdac17f958d2ee523a2206206994597c13d831ec7',
    'USDC': '0xa0b86a33e6ba3e5b3e7b9b8c9a8e3e2d2c1a9b8c'
  },
  // Arbitrum (Chain ID: 42161)
  42161: {
    'USDT': '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
    'USDC': '0xaf88d065e77c8cc2239327c5edb3a432268e5831'
  },
  // Polygon (Chain ID: 137)
  137: {
    'USDT': '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
    'USDC': '0x2791bca1f2de4661ed88a30c99a7a9449aa84174'
  }
};

const validateTokenForNetwork = async (tokenAddress, chainId) => {
  try {
    const lowerTokenAddress = tokenAddress.toLowerCase();
    
    // Check if this token address belongs to a different network
    for (const [networkId, tokens] of Object.entries(KNOWN_TOKEN_ADDRESSES)) {
      const networkIdNum = parseInt(networkId);
      
      // Skip current network
      if (networkIdNum === chainId) continue;
      
      // Check if this address belongs to another network
      for (const [symbol, address] of Object.entries(tokens)) {
        if (address.toLowerCase() === lowerTokenAddress) {
          console.error(`🚫 API ERROR: Token ${symbol} address ${tokenAddress} belongs to network ${networkId}, not ${chainId}`);
          return false; // Block this token as it's from wrong network
        }
      }
    }
    
    return true; // Token passed validation
  } catch (error) {
    console.warn(`⚠️ Token validation failed for ${tokenAddress}:`, error);
    return true; // Default to true to avoid blocking valid tokens
  }
};

// Fallback system that tries multiple APIs
export const fetchTokenBalancesWithFallback = async (walletAddress, chainId) => {
  console.log(`🔍 Fetching tokens for wallet: ${walletAddress}, chain: ${chainId}`);
  
  // Clear any existing cached data for different networks
  const cacheKey = `tokens_${walletAddress}_${chainId}`;
  
  // Try APIs in order of preference
  const apis = [
    { name: "Moralis", func: fetchTokensFromMoralis },
    { name: "Etherscan", func: fetchTokensFromEtherscan },
    { name: "Alchemy", func: fetchTokensFromAlchemy },
    { name: "Covalent", func: fetchTokenBalancesFromCovalent }
  ];
  
  let hasConfiguredAPI = false;
  
  for (const api of apis) {
    try {
      console.log(`🚀 Trying ${api.name} API for chain ${chainId}...`);
      const result = await api.func(walletAddress, chainId);
      
      // Check if API was actually attempted (not skipped due to missing key)
      if (result !== null) {
        hasConfiguredAPI = true;
      }
      
      if (result && result.length > 0) {
        console.log(`✅ Successfully fetched ${result.length} tokens from ${api.name} for chain ${chainId}`);
        
        // Validate each token and filter out wrong network tokens
        const validatedTokens = [];
        
        for (const token of result) {
          const isValid = await validateTokenForNetwork(token.tokenAddress, chainId);
          
          if (isValid) {
            validatedTokens.push({
              ...token,
              chainId: chainId, // Ensure each token knows its network
              source: api.name  // Track which API provided this token
            });
          } else {
            console.warn(`🚫 Filtered out invalid token from ${api.name}:`, {
              symbol: token.symbol,
              address: token.tokenAddress,
              reportedChain: chainId,
              actualChain: 'unknown'
            });
          }
        }
        
        console.log(`📊 Validated tokens for chain ${chainId} (${validatedTokens.length}/${result.length}):`, 
          validatedTokens.map(t => `${t.symbol} (${t.tokenAddress.substring(0, 8)}...) from ${t.source}`));
        
        if (validatedTokens.length > 0) {
          // Final check: ensure all tokens are for the correct network
          const finalTokens = validatedTokens.filter(token => {
            if (token.requestedChainId && token.requestedChainId !== chainId) {
              console.error(`🚫 FINAL FILTER: Token ${token.symbol} was requested for chain ${token.requestedChainId} but we need ${chainId}`);
              return false;
            }
            return true;
          });
          
          if (finalTokens.length > 0) {
            console.log(`✅ Final token list for chain ${chainId}:`, finalTokens.map(t => `${t.symbol} (${t.tokenAddress.substring(0, 8)}...)`));
            return finalTokens;
          } else {
            console.warn(`⚠️ All tokens from ${api.name} were filtered out in final validation for chain ${chainId}`);
          }
        } else {
          console.warn(`⚠️ All tokens from ${api.name} were filtered out as invalid for chain ${chainId}`);
        }
      } else if (result !== null) {
        console.log(`⚠️ ${api.name} returned no tokens for chain ${chainId}`);
      }
    } catch (error) {
      console.warn(`❌ ${api.name} API failed for chain ${chainId}:`, error.message);
      hasConfiguredAPI = true; // API was attempted but failed
    }
  }
  
  if (!hasConfiguredAPI) {
    console.log(`ℹ️ No API keys configured for chain ${chainId}. Manual token entry available.`);
    const manualInfo = getManualTokenEntry();
    console.log("📝 Manual entry instructions:", manualInfo.instructions);
  } else {
    console.warn(`🚫 All configured APIs failed for chain ${chainId}, returning empty array`);
  }
  
  return [];
};

export default fetchTokenBalancesFromCovalent;

export const isValidAddress = (address) => {
  try {
    // Trim whitespace and ensure we have a string
    const cleanAddress = address?.toString()?.trim();
    
    if (!cleanAddress) {
      return false;
    }
    
    // Check basic address format first
    if (!Web3.utils.isAddress(cleanAddress)) {
      return false;
    }
    
    // Additional security checks
    if (cleanAddress.length !== 42 || !cleanAddress.startsWith('0x')) {
      return false;
    }
    
    // Note: Removed strict checksum validation to allow lowercase addresses
    // Web3.utils.isAddress() already validates the format properly
    
    return true;
  } catch (error) {
    console.error("Address validation error:", error);
    return false;
  }
};

// Function to detect potential address manipulation
export const detectAddressManipulation = (originalAddress, currentAddress) => {
  if (!originalAddress || !currentAddress) return false;
  
  try {
    const cleanOriginal = originalAddress.toLowerCase().trim();
    const cleanCurrent = currentAddress.toLowerCase().trim();
    
    // Check if addresses are different
    if (cleanOriginal !== cleanCurrent) {
      console.warn("Potential address manipulation detected!", {
        original: originalAddress,
        current: currentAddress
      });
      return true;
    }
    
    return false;
  } catch (error) {
    console.error("Address manipulation check error:", error);
    return true; // Fail safe - assume manipulation if error occurs
  }
};

// Enhanced duplicate check with manipulation detection
export const checkDuplicatesAndValidity = async (lines) => {
  let seen = {};
  let errors = [];
  let addressHistory = new Map(); // Track address changes

  for (let i = 0; i < lines?.length; i++) {
    const line = lines[i];
    let address = line?.address;
    
    // Store original address for manipulation check
    const originalAddress = address;

    // Basic validation
    if (!isValidAddress(address)) {
      errors.push(`Line ${i + 1}: Invalid address ${address}`);
      continue;
    }

    // Check for address manipulation
    if (addressHistory.has(address)) {
      const original = addressHistory.get(address);
      if (detectAddressManipulation(original, address)) {
        errors.push(`Line ${i + 1}: Potential address manipulation detected`);
        continue;
      }
    }

    // Amount validation with enhanced precision
    if (line?.amount) {
      if (!/^\d+(\.\d{1,4})?$/.test(line?.amount)) {
        errors.push(
          `Line ${i + 1}: Invalid amount ${line?.amount}. Amount must have at most four decimal places.`
        );
        continue;
      }
      
      // Additional amount validation
      const amount = parseFloat(line.amount);
      if (isNaN(amount) || amount <= 0) {
        errors.push(`Line ${i + 1}: Amount must be greater than 0`);
        continue;
      }
    }

    // Duplicate check
    if (seen[address]) {
      errors.push(
        `Line ${i + 1}: Duplicate address ${address} found on Line ${seen[address]}`
      );
    } else {
      seen[address] = i + 1;
      addressHistory.set(address, originalAddress);
    }
  }

  return errors;
};

export const checkDuplicatesAndValidityAddress = async (addresses) => {
  let seen = {};
  let errors = [];

  for (let i = 0; i < addresses?.length; i++) {
    const address = addresses[i];

    if (!isValidAddress(address)) {
      errors.push(`Line ${i + 1}: Invalid address ${address}`);
      continue; // Skip duplicate check for invalid addresses
    }

    if (seen[address]) {
      errors.push(
        `Line ${i + 1}: Duplicate address ${address} found on Line ${
          seen[address]
        }`
      );
    } else {
      seen[address] = i + 1; // Store line number where address is seen
    }
  }

  return errors;
};

export const calculateTotalAmount = (dataArray) => {
  return dataArray.reduce((total, item) => {
    // Parse the amount as a float and add it to the total
    return total + parseFloat(item.amount);
  }, 0);
};

export const formatToFourDecimalPlaces = (num) => {
  const roundedNum = Math.round(Number(num) * 10000) / 10000; // Round to 4 decimal places
  return roundedNum.toString();
};

export const validateFormInputs = (message, errors) => {
  const res = errors?.filter((err) => err === message);
  return res?.length > 0 ? true : false;
};

export function formatTransactionHash(hash, startLength = 10, endLength = 5) {
  if (!hash || hash.length < startLength + endLength) {
    return hash; // Return the original hash if it's too short to format
  }

  const start = hash.substring(0, startLength);
  const end = hash.substring(hash.length - endLength, hash.length);

  return `${start}...${end}`;
}

export function copyToClipboard(text) {
  // Check if the browser supports the Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    // Use the Clipboard API to copy the text
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Text copied to clipboard!");
      })
      .catch((err) => {
        toast.error("Failed to copy text: ", err);
      });
  } else {
    // Fallback method for older browsers
    let textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid showing the textarea
    textArea.style.position = "fixed";
    textArea.style.top = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      toast.success("Text copied to clipboard (fallback)!");
    } catch (err) {
      toast.success("Failed to copy text: ", err);
    }

    document.body.removeChild(textArea);
  }
}

export function generateRandom(quantity) {
  let randomNumberString = "";

  for (let i = 0; i < quantity; i++) {
    const randomDigit = Math.floor(Math.random() * 10); // Generates a random digit between 0-9
    randomNumberString += randomDigit;
  }

  return randomNumberString;
}

export function hasTimeStarted(startTime) {
  const now = Date.now();
  const start = Number(startTime);

  if (isNaN(start)) {
    console.error("Invalid start time format");
    return false;
  }

  return now >= start;
}


export const getRemainingDays = (startTime, numberOFDays) => {
  const start = startTime * 1000; // convert to ms
  const end = start + numberOFDays * 24 * 60 * 60 * 1000;
  const now = Date.now();

  const remainingMs = end - now;
  const remainingDays = Math.ceil(remainingMs / (1000 * 60 * 60 * 24));

  return remainingDays > 0 ? remainingDays : 0;
};
